import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SortDescriptor } from '@progress/kendo-data-query';
import { CustomReportsService } from "@app/modules/custom-reports/services/reports.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'reports-list',
    templateUrl: './reports-list.component.html',
    styleUrls: ['./reports-list.component.scss']
})
export class ReportsListComponent implements OnInit {
    @Input() refreshView: boolean;
    public bindingType: String = 'array';
    public view: Observable<GridDataResult>;
    public gridData: any;
    public gridDataResult: GridDataResult;
    pageSize: number = 20;
    skip: number = 0;
    isLoading: boolean;

    getRequest: any;

    public searchFilterString: string;
    public searchValue: string;

    public sort: SortDescriptor[] = [];
    public sortString: string = 'name-asc';
    public reportType: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private reportsService: CustomReportsService,
    ) {
    }

    ngOnInit(): void {
        this.reportType = this.getTypeInURL();
    }

    getTypeInURL(): string {
        let IdInURL: string;

        this.route.paramMap.subscribe(
            params => IdInURL = params.get("type")
        )

        return IdInURL;
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.refreshView && (changes.refreshView.currentValue !== changes.refreshView.previousValue)) {
            this.getData();
        }
    }

    getData() {
        this.isLoading = true;

        this.getRequest = this.reportsService.getNewReports(this.pageSize, this.skip, this.searchFilterString, this.sortString)
        .pipe(
            finalize(() => {
                this.isLoading = false;
            })
        )
        .subscribe(
            res => {
                this.gridDataResult = {
                    data: res.data,
                    total: res.total,
                };
            }
        );
    }

    backToReportGroups() {
        this.router.navigate([`Reports`]);
    }
}
